module.exports = __webpack_public_path__ + "static/media/employer-profile-banner.98b2c44c.svg";